/* eslint-disable import/no-unresolved */
import axios from "axios";
import API_URLS from "src/config/API_URLS";
import store from "src/redux/store";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";
import logoutCall from "src/services/Logout";
import StorageService from "../Storage/storageService";

const axiosInstance = axios.create({
  baseURL: API_URLS.baseURL
});
axiosInstance.interceptors.request.use(
  (config: any) => {
    let token = StorageService.getFromLocalStorage("token") || {};
    token = config.url === API_URLS.login ? token?.idToken : token?.accessToken;
    const newConfig = {
      ...config,
      headers: {
        ...config.headers,
        ...(token && { Authorization: `Bearer ${token}` })
      }
    };
    return newConfig;
  },
  (err: any) => Promise.reject(err)
);

axiosInstance.interceptors.response.use(
  (response) => response?.data,
  (error) => {
    const { message, status } = error?.response?.data || {};
    // console.log("Log", error.config.url);
    if (error.config.url !== API_URLS.login && status === 401) {
      const userId = StorageService.getFromLocalStorage("user")?.id;
      if (userId) {
        logoutCall(userId);
      }
      StorageService.removeKeyFromLocalStorage("token");
      StorageService.removeKeyFromLocalStorage("user");
      StorageService.removeKeyFromLocalStorage("samlToken");
      const currLocation = window.location.pathname + window.location.search;
      window.location.href = `/?redirectTo=${currLocation}`;
    }
    store.dispatch(
      SET_TOAST_ERROR({
        error: true,
        message: message || "Something went Wrong"
      })
    );
    return Promise.reject(error?.response?.data);
  }
);

export default axiosInstance;
